import React from "react";
import { CardHeader, Chip, Tooltip, makeStyles } from "@material-ui/core";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import { i18n } from "../../translate/i18n";
import ContactAvatar from "../ContactAvatar";
import formatPhone from "../../helpers/formatPhone";

const statusConfig = {
	open:    { label: "Em Atendimento", color: "#2D7BE8", bg: "rgba(45,123,232,0.1)" },
	pending: { label: "Pendente",       color: "#f59e0b", bg: "rgba(245,158,11,0.1)" },
	closed:  { label: "Resolvido",      color: "#16a34a", bg: "rgba(22,163,74,0.1)"  },
};

// Deixa o texto do cabeçalho encolher (com reticências) em vez de passar por
// baixo dos botões de ação quando o espaço fica apertado.
const useStyles = makeStyles(() => ({
	content: { minWidth: 0, overflow: "hidden" },
}));

const TicketInfo = ({ contact, ticket, onClick }) => {
	const classes = useStyles();
	const attendant = ticket.user;
	const queue     = ticket.queue;
	const status    = statusConfig[ticket.status] || null;

	const contactName =
		document.body.offsetWidth < 600 && contact.name?.length > 10
			? contact.name.substring(0, 10) + "…"
			: contact.name;

	const userName = attendant
		? (document.body.offsetWidth < 600
			? attendant.name
			: `${i18n.t("messagesList.header.assignedTo")} ${attendant.name}`)
		: null;

	// Linha de apoio: telefone · departamento · atendente
	const subheader = [
		contact.number && !ticket.isGroup ? formatPhone(contact.number) : null,
		queue?.name || null,
		userName,
	].filter(Boolean).join(" · ");

	return (
		<CardHeader
			classes={{ content: classes.content }}
			onClick={onClick}
			style={{ cursor: "pointer", padding: "10px 16px", flex: 1, minWidth: 0 }}
			titleTypographyProps={{ noWrap: true, variant: "body1" }}
			subheaderTypographyProps={{ noWrap: true, variant: "body2" }}
			avatar={
				<Tooltip title="Ver informações do contato" placement="bottom">
					<div style={{ position: "relative", display: "inline-flex" }}>
						<ContactAvatar
							src={contact.profilePicUrl}
							name={contact.name}
							style={{ width: 42, height: 42 }}
						/>
						<InfoOutlinedIcon
							style={{
								position: "absolute",
								bottom: -2,
								right: -2,
								fontSize: 14,
								color: "#fff",
								backgroundColor: "#2D7BE8",
								borderRadius: "50%",
								padding: 1,
							}}
						/>
					</div>
				</Tooltip>
			}
			title={
				<span style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: 4 }}>
					<span style={{ fontWeight: 600 }}>{contactName}</span>

					{/* Status do ticket */}
					{status && (
						<Chip
							label={status.label}
							size="small"
							style={{
								height: 18,
								fontSize: "0.62rem",
								borderRadius: 9,
								backgroundColor: status.bg,
								color: status.color,
								fontWeight: 700,
								border: `1px solid ${status.color}33`,
							}}
						/>
					)}

				</span>
			}
			subheader={subheader}
		/>
	);
};

export default TicketInfo;
